{
	"add": "Añadir producto",
	"price": "Precio de venta",
	"product": "Producto",
	"productInformation": "Información del producto",
	"title": "Agregar producto al menú",
	"validateField": "Campo obligatorio"
}
